import { isArray } from 'lodash';
import { ShopConfigResponse } from '../types/contentful/shopConfig';
import { isEUCountry } from '../util/countryCodes';
import { useShopConfigV2 } from './shopConfig';

export const isSellerGeneratedLabelsEnabled = (shopConfig: ShopConfigResponse) => {
  const enabledFulfillmentMethods =
    shopConfig.shippingConfig?.enabledPeerToPeerFulfillmentMethods ?? [];
  if (enabledFulfillmentMethods.length === 1) {
    return enabledFulfillmentMethods[0] === 'PEER';
  }

  const allowedOriginToDestinationCountries =
    shopConfig.internationalConfig?.allowedOriginToDestinationCountries ?? {};

  return Object.entries(allowedOriginToDestinationCountries).some(
    ([originCountry, destinationCountries]) =>
      isEUCountry(originCountry) &&
      isArray(destinationCountries) &&
      destinationCountries.some((code) => code !== originCountry)
  );
};

export const useSellerGeneratedLabels = () => {
  const shopConfig = useShopConfigV2();
  return isSellerGeneratedLabelsEnabled(shopConfig);
};
